import type { ViewerConfig } from '../config.js';
import { LEXUS_NX_PALETTE } from '../../ui/paintSwatches.js';

export const RAV4_HDRI_MAP: Record<string, string> = {
  low_highlight: 'assets/hdri/low_highlight.exr',
  low_highlight_low: 'assets/hdri/low_highlight_low.exr',
  test5: 'assets/hdri/test5.exr',
  test6_small: 'assets/hdri/test6_small.exr',
  sunset: 'assets/hdri/venice_sunset_1k.hdr',
  studio: 'assets/hdri/studio_small_03_1k.hdr',
};

export const RAV4: ViewerConfig = {
  id: 'rav4',
  rootName: 'rav4_root',
  // 기본(데스크톱): 베이크+aggressive join (draw call 1099→174, role 파생 베이크·tireAO 재질명 보존).
  // 모바일: rav4-mobile.glb (meshopt 50% 데시메이트 8.4M tris — iOS WebGL 메모리 캡 회피, 데스크톱 원본 무손상 LOD).
  // ?agg=0 → 비베이크 named GLB (카테고리 패널 저작·mesh 이름 편집용, 데스크톱 한정).
  // ?mglb=<name> → 모바일 GLB 를 rav4-<name>.glb 로 오버라이드 (실기기 LOD 후보 테스트용).
  assets: [{
    category: 'O',
    glb: (p, isMobile) =>
      p.get('agg') === '0' ? 'assets/models/rav4.glb'
        : isMobile ? `assets/models/rav4-${p.get('mglb') ?? 'mobile'}.glb`
          : 'assets/models/rav4-aggressive.glb',
  }],
  groups: 'data/material-groups/rav4.json',
  rolePbr: 'data/role-pbr-rav4.json',
  hdriDefault: 'low_highlight',
  hdriMobile: 'low_highlight_low',
  shadowTexture: 'assets/shadow/exterior-shadow.png',
  palette: LEXUS_NX_PALETTE,
  tireAO: {
    tireMeshNames: ['_42652_42840_01_', '_42652_42840_02_', '_42652_42840_05_', '_42652_42840_06_'],
    bakedGlb: 'assets/lightmap/rav4-tire-baked.glb',
    // 데스크톱: 4096² 원본. 모바일: 2048² 리샘플(iOS GPU 텍스처 풋프린트 85MB→21MB, AO 저주파라 시각 손실 없음).
    aoTexture: (_p, isMobile) =>
      isMobile ? 'assets/lightmap/tire-ao/rav4-canonical-mobile.png'
        : 'assets/lightmap/tire-ao/rav4-canonical.png',
  },
  pairReference: { glb: 'assets/models/exterior.glb', groups: 'data/material-groups/800b-O.json' },
  // 데스크톱: 원본 액세서리. 모바일: ratio 0.4 데시메이트(2.21M→0.89M tris) — iOS OOM 누적 풋프린트 절감.
  accessories: (_p, isMobile) =>
    isMobile ? 'assets/models/rav4-accessories-mobile.glb'
      : 'assets/models/rav4-accessories.glb',
  saveModel: 'rav4',
};
